module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-12f6e127"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/Index.vue
// module id = 3
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13